import React, { useEffect, useState } from 'react'
import { menuService } from '../services/menuService'

const TestMenus: React.FC = () => {
  const [menus, setMenus] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadMenus = async () => {
      try {
        console.log('TestMenus: Starting to load menus...')
        setLoading(true)
        const data = await menuService.getMenus()
        console.log('TestMenus: Menus loaded:', data)
        setMenus(data)
        setError(null)
      } catch (err: any) {
        console.error('TestMenus: Error loading menus:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    loadMenus()
  }, [])

  if (loading) {
    return (
      <div className="p-4 border-2 border-blue-500 bg-blue-50">
        <h3 className="font-bold text-blue-800">TEST COMPONENT - Loading...</h3>
        <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full"></div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="p-4 border-2 border-red-500 bg-red-50">
        <h3 className="font-bold text-red-800">TEST COMPONENT - Error</h3>
        <p className="text-red-700">{error}</p>
      </div>
    )
  }

  return (
    <div className="p-4 border-2 border-green-500 bg-green-50">
      <h3 className="font-bold text-green-800">TEST COMPONENT - Success</h3>
      <p className="text-green-700">Loaded {menus.length} menus:</p>
      <ul className="list-disc list-inside mt-2">
        {menus.map((menu) => (
          <li key={menu.id} className="text-sm text-green-700">
            {menu.name} ({menu.is_active ? 'Active' : 'Inactive'})
          </li>
        ))}
      </ul>
    </div>
  )
}

export default TestMenus
